import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TaskListComponent } from './task-list.component';
import { TaskViewComponent } from './task-view.component';
import { SupplierSelectDialogComponent } from './supplierSelectDialog.component';
import { TaskListStateModule } from './task-list-state.module';
import { PaginatorModule } from 'primeng/paginator';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import {CheckboxModule} from 'primeng/checkbox';
import { NgStringPipesModule } from 'ngx-pipes';
import {InputTextModule} from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { TreeTableModule } from 'primeng/treetable';
import {ListboxModule} from 'primeng/listbox';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import {PanelModule} from 'primeng/panel';
import {PanelMenuModule} from 'primeng/panelmenu';
import {ContextMenuModule} from 'primeng/contextmenu';
import { MultiSelectModule } from 'primeng/multiselect';
import { TaskEditDialogComponent } from './task-edit-dialog.component';
import {FileUploadModule} from 'primeng/fileupload';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DatePickerModule } from 'primeng/datepicker';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { CommonCheckService, MandantenService } from 'FoxxyLib';
import { MatIconModule } from '@angular/material/icon';

import { FormsModule } from '@angular/forms';
import { DialogService } from 'primeng/dynamicdialog';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TasklistEffects } from './store/effects';
import { featureNameTasklist, reducerTasklist } from './store';
import { TextareaModule } from 'primeng/textarea';

@NgModule({ exports: [TaskListComponent, TaskViewComponent, SupplierSelectDialogComponent, TaskEditDialogComponent],
    declarations: [TaskListComponent, TaskViewComponent, SupplierSelectDialogComponent, TaskEditDialogComponent], imports: [CommonModule,
      TaskListStateModule, PaginatorModule, TooltipModule, ProgressSpinnerModule, ButtonModule,
        NgStringPipesModule, RadioButtonModule, SelectModule, TableModule, TreeTableModule, CheckboxModule, NgxChartsModule, PanelModule, PanelMenuModule,
        FormsModule, TextareaModule,
        StoreModule.forFeature(featureNameTasklist, reducerTasklist),
                EffectsModule.forFeature([TasklistEffects]),
        ContextMenuModule, InputTextModule, ListboxModule, MultiSelectModule,  FileUploadModule, MatIconModule,
        TextareaModule,
        DatePickerModule, ToastModule, ConfirmDialogModule, InputNumberModule], providers: [
          DialogService, MandantenService,
          ConfirmationService, CommonCheckService, provideHttpClient(withInterceptorsFromDi())] })
export class TaskListModule { }
